/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_PlaceholderInputs */

const en_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`username`)
};

const de_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`benutzername`)
};

const pt_br2_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nome_de_usuario`)
};

const tr_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kullanici_adi`)
};

const zh_cn2_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户名`)
};

const zh_hk2_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用戶名稱`)
};

const ko_kr2_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자_이름`)
};

const ru_ru2_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`имя_пользователя`)
};

const es_419_onboarding_v1_username_placeholder = /** @type {(inputs: Onboarding_V1_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nombre_de_usuario`)
};

/**
* | output |
* | --- |
* | "username" |
*
* @param {Onboarding_V1_Username_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_placeholder = /** @type {((inputs?: Onboarding_V1_Username_PlaceholderInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_PlaceholderInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_placeholder(inputs)
	if (locale === "de") return de_onboarding_v1_username_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_placeholder(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_placeholder(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_placeholder(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_placeholder(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_placeholder(inputs)
	return es_419_onboarding_v1_username_placeholder(inputs)
});